import Cookies from 'js-cookie';
import isMobile from 'is-mobile';
import { addErrorToReport } from '@americanexpress/one-app-ducks';
import { getOneIdentityCorrelationId, getActiveLocale } from './selectors';
import { clean } from './utils';

export const DEFAULT_COLLECTION_METHOD = 'reportError';

const getLocale = (state) => getActiveLocale(state)
  || Cookies.get('axplocale')
  || global.navigator?.language
  || 'en-US';

const collectReport = (state) => clean({
  agentId: Cookies.get('agent-id'),
  guid: Cookies.get('blueboxpublic'),
  locale: getLocale(state),
  mobile: global.window && isMobile(),
  connection: global.navigator && {
    type: navigator.connection?.type,
    effectiveType: navigator.connection?.effectiveType,
    online: navigator.onLine,
  },
  referrer: global.document?.referrer,
  oneIdentityCorrelationId: getOneIdentityCorrelationId(state),
});

/**
 * Reports a runtime error to the application server. Augments the report with information collected
 * from One Identity state and the current browser session.
 *
 * @param {Error} error The error to report.
 * @param {*} [otherData] An object containing extra information to add to the report.
 * @returns {ReportErrorThunkAction}
 *  A Promise that resolves after the report has been submitted to the application server.
 */
export default function reportError(error, otherData) {
  return (dispatch, getState) => dispatch(
    addErrorToReport(error, {
      collectionMethod: DEFAULT_COLLECTION_METHOD,
      ...collectReport(getState()),
      ...otherData,
    })
  );
}

/**
 * Indicates that an error report was received by the application server.
 *
 * @typedef {{ thankYou: boolean }} ReportErrorServerResponse
 */

/**
 * A {@link https://github.com/reduxjs/redux-thunk Redux Thunk} action that returns a Promise that
 * resolves to an object with a `thankYou` property set to true after the report has been sent to
 * the application server.
 *
 * @typedef {import('redux-thunk').ThunkAction<
 *  PromiseLike<?ReportErrorServerResponse>, any, any, any
 * >} ReportErrorThunkAction
 */
